import styled from 'styled-components';
import IconPrint from '../Icons/IconPrint';
import IconButton from '../Button/IconButton';
import { uiPrimaryColor } from '../../style/colors';

const Button = styled(IconButton)`
    background: #eee;
    border-radius: 4px;
    color: ${uiPrimaryColor};
    padding: 4px 6px 2px;
    margin-bottom: 8px;

    &:hover {
        background-color: #fff;
    }
`;

const PrintButton = ({ className }) => {
    return (
        <Button
            className={`dont-print ${className}`}
            onClick={() => window.print()}
            title="Print"
        >
            <IconPrint width="24px" height="24px" />
        </Button>
    );
};

export default PrintButton;
